import * as Types from 'constants/ActionTypes';

const locales = (state = {
    inProgress: false,
    didInvalidate: false,
    data: [],
}, action) => {
    switch (action.type) {
        case Types.FETCH_APPLICATION_LOCALES:
        case Types.CREATE_APPLICATION_LOCALE:
            return Object.assign({}, state, {
                inProgress: true,
                didInvalidate: false
            })
        case Types.FETCH_APPLICATION_LOCALES_SUCCESS:
            return Object.assign({}, state, {
                inProgress: false,
                didInvalidate: false,
                data: action.payload,
                lastUpdated: action.receivedAt
            })
        case Types.CREATE_APPLICATION_LOCALE_SUCCESS:
            return Object.assign({}, state, {
                inProgress: false,
                didInvalidate: false,
                data: [...state.data, action.payload],
                lastUpdated: action.receivedAt
            })
        case Types.DELETE_APPLICATION_LOCALE_SUCCESS:
            state.data.splice(state.data.findIndex(l => (l.key === action.payload.key)), 1)
            return Object.assign({}, state, {
                inProgress: false,
                didInvalidate: false,
                data: [...state.data],
                lastUpdated: action.receivedAt
            })
        case Types.FETCH_APPLICATION_LOCALES_FAILURE:
        case Types.CREATE_APPLICATION_LOCALE_FAILURE:
        case Types.DELETE_APPLICATION_LOCALE_FAILURE:
            return Object.assign({}, state, {
                inProgress: false,
                didInvalidate: false,
                lastUpdated: action.receivedAt
            })
        default:
            return state
    }
};

export default locales